import { render, staticRenderFns } from "./superAceX.vue?vue&type=template&id=0fc23a58&scoped=true"
import script from "./superAceX.vue?vue&type=script&lang=js"
export * from "./superAceX.vue?vue&type=script&lang=js"
import style0 from "./superAceX.vue?vue&type=style&index=0&id=0fc23a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc23a58",
  null
  
)

export default component.exports